<!-- Builder End -->
<div id="{{position}}" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <header class="app-header-background pt-40 pb-40 global-max-width"
      [attr.data-aos]="allElementAnimation ? allElementAnimation : null">
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlexAlign="center" [attr.data-aos]="imageAnimation ? imageAnimation : null">
          <ng-container *ngIf="bannerLink; else nolink">
            <a *ngIf="bannerLink && bannerLink.includes('#') && bannerLink.length<5" style="cursor: pointer"
              (click)='navigateTo(bannerLink)' rel="noopener">
              <img [alt]="banner" class="image-bancomponent" [src]="bannerSource" />
            </a>
            <a *ngIf="bannerLink && bannerLink.length>=5" style="cursor: pointer"
              (click)="clickExternalLink(bannerLink)" rel="noopener">
              <img [alt]="banner" class="image-bancomponent" [src]="bannerSource" />
            </a>
          </ng-container>
          <ng-template #nolink>
            <img [alt]="banner" class="image-bancomponent" [src]="bannerSource" />
          </ng-template>
        </div>
      </div>
    </header>
  </div>
</div>